import ColorDropdownSelect from '../../../common/ColorDropdownSelect';
import { PropertyCaption } from '../../PropertyCaption';

import type { ColorControlSetting, ControlRenderProps } from '../ControlTypes';

export const ColorControl = ({
  control,
  modifyProperty,
  unifiedValue,
}: ControlRenderProps<ColorControlSetting>) => {
  const defaultValue =
    typeof unifiedValue === 'string' ? unifiedValue : undefined;

  return (
    <>
      <PropertyCaption>{control.label}</PropertyCaption>
      <ColorDropdownSelect
        action={(_p, value) =>
          modifyProperty(control.elementPaths, control.property, value)
        }
        propertyName={control.property}
        defaultValue={defaultValue}
      />
    </>
  );
};
